import { Modality } from '../api/client'

/** The modalities a classifier can be built for, in display order. */
export const MODALITY_OPTIONS: { value: Modality; label: string }[] = [
    { value: Modality.Text, label: 'Text' },
    { value: Modality.Image, label: 'Image' }
]
